<template>
  <section class="authors">
    <div class="authors__intro content__text" v-html="content.data.authors.intro">
      <br />
      <br />
      <span v-html="content.data.authors.content"></span>
    
    </div>
    <div class="authors__names">
      <div v-for="(item) in content.data.authors.names" :key="item">
        {{ item }}
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Authors",
  inject: ["content"],
};
</script>
